import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './css/master.css';

Vue.config.productionTip = false

// Check if URL contains auth tokens (from Supabase redirect)
function checkForAuthTokens() {
  const hash = window.location.hash
  // Check if hash contains access_token (Supabase auth redirect)
  if (hash && hash.includes('access_token=') && !hash.includes('/auth/callback')) {
    // Extract tokens and redirect to auth callback with a full page reload
    const tokenPart = hash.includes('#/') ? hash.split('#/')[1] : hash.substring(1)
    window.location.href = window.location.origin + window.location.pathname + `#/auth/callback#${tokenPart}`
    window.location.reload()
    return true
  }
  return false
}

// Initialize auth listener and fetch config before mounting app
async function initApp() {
  // Check for auth tokens in URL and redirect if needed
  if (checkForAuthTokens()) {
    return // Let the page reload with new hash
  }

  // Check for existing auth session
  await store.dispatch('checkAuth')

  // Fetch site configuration from Supabase
  await store.dispatch('fetchConfig')

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}

initApp()
